import { Link } from "react-router-dom";
import { useForgotPasswordViewModel } from "../../viewmodel/useForgotPasswordViewModel";
import { useInlineLoading } from "@/shared/loading";
import { routes } from "@/app/navigation/routes";
import styles from "./ForgotPasswordForm.module.css";
import { forgotPasswordImage } from "@/assets/images";

/**
 * ForgotPasswordForm Component
 * Pure presentational component - all logic in ViewModel
 */
export const ForgotPasswordForm = () => {
  const { email, isLoading, emailError, updateEmail, handleSubmit } = useForgotPasswordViewModel();
  const BUTTON_ID = "forgot-password-button";
  const { isLoading: isInlineLoading } = useInlineLoading(BUTTON_ID);
  const buttonLoading = isLoading || isInlineLoading;

  return (
    <div className={styles.formContainer}>
      <img src={forgotPasswordImage} alt="Forgot Password" className={styles.forgotPasswordImage} />
      <h1 className={styles.title}>Forgot Password</h1>
      <p className={styles.subtitle}>
        Enter your email address and we&apos;ll send you a link to reset your password.
      </p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label className={styles.label} htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className={`${styles.input} ${emailError ? styles.inputError : ""}`}
            value={email}
            onChange={(e) => updateEmail(e.target.value)}
            placeholder="e.g. username@kinety.com"
          />
          {emailError && <div className={styles.errorMessage}>{emailError}</div>}
        </div>

        <button
          id={BUTTON_ID}
          type="submit"
          className={styles.continueButton}
          disabled={buttonLoading}
        >
          {buttonLoading ? "Loading..." : "Send Reset Link"}
        </button>
      </form>

      {/* Back to Login Link */}
      <div className={styles.backToLoginLink}>
        <Link to={routes.login} className={styles.backToLoginLinkText}>
          Back to Login
        </Link>
      </div>
    </div>
  );
};
